export const formatCmsDateFields = (obj) => {
  const dateFields = obj?.reduce((acc, field) => {
    if (field?.name) {
      acc[field.name] = field.date;
    }
    return acc;
  }, {});
  return dateFields;
};
